import { render, staticRenderFns } from "./navmenu.vue?vue&type=template&id=af22d8a8&scoped=true"
import script from "./navmenu.vue?vue&type=script&lang=ts"
export * from "./navmenu.vue?vue&type=script&lang=ts"
import style0 from "./navmenu.vue?vue&type=style&index=0&id=af22d8a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af22d8a8",
  null
  
)

export default component.exports